import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'coky-helper-dialog',
  template: `
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content [innerHTML]="data.text"></div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancelClick()">Cancelar</button>
      <button mat-button (click)="onOkClick()" class="{{data.type.toLowerCase()}}" cdkFocusInitial>{{data.button}}</button>
    </div>

  `
})
export class CokyHelperDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<CokyHelperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      type: "PRIMARY" | "SECONDARY" | "SUCCESS" | "DANGER" | "WARNING" | "INFO" | "DARK" | "WHITE" | "GRAY",
      title: string, text: string, button: string, action?: (() => any)
    }
  ) {

    this.data.button = this.data.button ? this.data.button : "Ok"
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onOkClick(): void {
    this.onCancelClick()
    if (typeof this.data.action == 'function') {
      this.data.action()
    }
  }


}

